<ng-multiselect-dropdown name="name"
                         [placeholder]="placeHolder"
                         [data]="dropdownList"                         
                         [disabled]="isDisabled"
                         [settings]="dropdownSettings"
                         (onSelect)="onItemSelect($event)"
                         (onDeSelect)="onItemDeSelect($event)"
                         (onSelectAll)="onSelectAll($event)"
                         (onDeSelectAll)="onDeSelectAll($event)">
</ng-multiselect-dropdown>
